import React, { Component } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import { ValidationHelper } from '../helpers/ValidationHelper';
import { ColourPalette } from '../styles/AppColourPalette';
import { AppConfig } from '../AppConfig';
import { CommonStyles } from '../styles/Styles';
import { AppTheme } from '../styles/AppTheme';
import {
  StyleSheet,
  css
} from 'aphrodite';

export class CheckboxComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value
    }
  }

  change = e => {
    this.setState({ value: e.target.value });
    this.props.setValue(e.target.value, this.props.formField.key)
  }

  render() {
    return (
      <FormControl className={this.props.headerView ? css(Styles.multiPickerForm) : css(Styles.inputCss)}>
        {this.props.formField.label &&
          <InputLabel
            className={css(Styles.inputLabel)}
            classes={{
              shrink: css(Styles.inputLabelShrink)
            }}>
            {this.props.formField.label}
          </InputLabel>
        }
        <Select
          multiple
          value={this.props.value}
          onChange={e => this.change(e)}
          className={this.props.headerView ? css(Styles.pickerInnerContainer) : css(Styles.dummyClass)}
          renderValue={selected => selected.join(', ')}
          renderValue={selected => (
            this.props.formField.options.map(item => {
              return (
                selected.map((key, index) => {
                  if(selected.length - 1 === index) {
                    return (
                      key === item.key &&
                      [item.name]
                    )
                  } else {
                    return (
                      key === item.key &&
                      [item.name] + ', '
                    )
                  }

                }))
            })
          )}
          disabled={this.props.disabled}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left'
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left'
            },
            getContentAnchorEl: null,
            classes: {
              paper: css(CommonStyles.menuItemContainerRoot),
              list: css(CommonStyles.menuItemListContainerRoot)
            }
          }}
          input={
            <Input
              disableUnderline={true}
            />
          }
          classes={{
            selectMenu: this.props.headerView ? css(Styles.selectOrgMenu) : this.props.action === 'viewInfo' ? css(Styles.selectMenu, Styles.textFieldContentInputView) : css(Styles.selectMenu),
            icon: this.props.action === 'viewInfo' ? css(Styles.selectIconView) : css(Styles.selectIcon),
          }}
        >
          {this.props.formField.options.map(item => {
            return (
              <MenuItem
                key={item.key}
                value={item.key}
                className={css(CommonStyles.menuItemContainer)}>
                <Checkbox
                  checked={this.props.value.indexOf(item.key) > -1}
                  className={css(Styles.selectCheckbox)} />
                <ListItemText primary={item.name} />
              </MenuItem>
            )
          })}
        </Select>

        {!this.props.headerView &&
          <FormHelperText
            className={css(Styles.errorMsgStyle)}>
            {!this.props.enableValidation ? '' : ValidationHelper.validateFields(this.props.formField, this.props.value)}
          </FormHelperText>
        }

      </FormControl>
    )
  }
}

const Styles = StyleSheet.create({
  inputCss: {
    margin: 8,
    flex: 1,
    color: AppTheme.white,
    minHeight: AppTheme.formFieldHeight
  },
  inputLabel: {
    color: AppTheme.white,
    marginLeft: 8,
    opacity: .6,
    zIndex: 1,
    pointerEvents: 'none',
    '@media(max-width: 767px)': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      right: 22,
    }
  },
  inputLabelShrink: {
    right: 'unset'
  },
  selectMenu: {
    backgroundColor: AppTheme.secondaryColor,
    color: AppTheme.white,
    paddingLeft: 8
  },
  textFieldContentInputView: {
    backgroundColor: AppTheme.primaryBackground,
  },
  selectIcon: {
    color: AppTheme.white,
    backgroundColor: AppTheme.secondaryColor,
    marginRight: 1,
  },
  selectIconView: {
    color: AppTheme.primaryBackground
  },
  selectCheckbox: {
    color: AppTheme.white
  },
  errorMsgStyle: {
    color: AppTheme.white,
    paddingLeft: 8
  },
  multiPickerForm: {
    '@media(max-width: 768px)': {
      flex: 1
    }
  },
  dummyClass: {
  },
  pickerInnerContainer: {
    color: AppTheme.white,
    marginRight: 10,
    '@media (max-width: 768px)': {
      //marginTop: 10,
      marginRight: 0,
    }
  },
  selectOrgMenu: {
    minWidth: 150,
    maxWidth: 150,
    backgroundColor: AppTheme.secondaryColor,
    color: AppTheme.white,
    fontSize: 15,
    padding: 7,
    display: 'flex',
    alignItems: 'center',
    borderRadius: 5,
    border: '1px solid ' + AppTheme.secondaryColor,
    ':hover': {
      border: '1px solid ' + ColourPalette.color3
    },
    '@media(max-width: 768px)': {
      minWidth: 'unset'
    }
  },
})


// WEBPACK FOOTER //
// ./src/components/CheckboxComponent.js